"use client";

import * as React from "react";
import { ChevronDownIcon } from "lucide-react";
import { format } from "date-fns";

import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { createPortal } from "react-dom";

export function Calendar22({
  id,
  onChange,
  value: defaultValue,
}: {
  id?: string;
  onChange: (value: Date | null) => void;
  value?: Date | null;
}) {
  const [open, setOpen] = React.useState(false);
  const [date, setDate] = React.useState<Date | null>(
    defaultValue ? new Date(defaultValue) : null
  );

  React.useEffect(() => {
    if (defaultValue) {
      setDate(new Date(defaultValue));
    }
  }, [defaultValue]);

  return (
    <div className="flex flex-col gap-3">
      <Popover modal={false} open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            id={id}
            className="w-full justify-between font-normal"
          >
            {date ? format(date, "MM/dd/yyyy") : "Select date"}
            <ChevronDownIcon />
          </Button>
        </PopoverTrigger>
        <PopoverContent portal={false} className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={date ?? undefined}
            captionLayout="dropdown"
            onSelect={(date) => {
              //   @ts-ignore
              setDate(format(date, "yyyy-MM-dd"));
              //   @ts-ignore
              onChange(format(date, "yyyy-MM-dd"));
              setOpen(false);
            }}
          />
        </PopoverContent>
      </Popover>
      <button
        className="!p-0 !-mt-1 hover:underline w-fit text-sm"
        type="button"
        onClick={() => {
          setDate(null);
          onChange(null);
        }}
      >
        Clear
      </button>
    </div>
  );
}
